import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  CampaignChar,
  Character,
} from "@dndModels";
import { User } from "@models";

import API from "@dndUtilities/system_api";
import SmartAPI from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";

import CharacterMainDetails from "@dndComponents/character/CharacterMainDetails";
import LoadingBox from "@components/input/LoadingBox";

import CharacterBackgroundButton from "@dndComponents/character/background/CharacterBackgroundButton";
import CharacterRaceButton from "@dndComponents/character/race/CharacterRaceButton";
import CharacterClassButton from "@dndComponents/character/classes/CharacterClassButton";
// import CharacterHP from "./misc/CharacterHP";
import CharacterRestButton from "@dndComponents/character/misc/CharacterRestButton";
import CharacterInspirationButton from "@dndComponents/character/misc/CharacterInspirationButton";
import CharacterGiftButton from "@dndComponents/character/gifts/CharacterGiftButton";
import CharacterImageButton from "@dndComponents/character/misc/CharacterImageButton";
import CharacterSpeedButton from "@dndComponents/character/misc/CharacterSpeedButton";
import CharacterACButton from "@dndComponents/character/misc/CharacterACButton";
import CharacterTransformButton from "@dndComponents/character/transform/CharacterTransformButton";
import CharacterSizeButton from "@dndComponents/character/misc/CharacterSizeButton";
import CharacterKnowledgeButton from "@dndComponents/character/knowledge/CharacterKnowledgeButton";
import CustomRolls from "@dndComponents/character/CustomRolls";
import CharacterInitiative from "@dndComponents/character/misc/CharacterInitiative";
import HPInput from "@dndComponents/other/HPInput";
import CharacterAdvantageButton from "@dndComponents/character/misc/CharacterAdvantageButton";
import CharacterColorsButton from "@dndComponents/character/colors/CharacterColorsButton";
import CharacterBastionButton from "@dndComponents/character/bastions/CharacterBastionButton";
import CharacterMailButton from "@dndComponents/character/receivables/CharacterMailButton";
import CharacterLevelDisplay from "@dndComponents/character/misc/CharacterLevelDisplay";
import CharacterProficiencyBonus from "@dndComponents/character/misc/CharacterProficiencyBonus";
import CharacterNotesButton from './misc/CharacterNotesButton';

interface Props { 
  char: Character;
  shared?: boolean;
}

const api = API.getInstance();
const smart_api = SmartAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSheet({ 
  char,
  shared = false,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading_detail, setLoadingDetail] = useState("");
  // const [campaign, setCampaign] = useState<Campaign | undefined>(undefined);
  // const [char_interface, setCharInterface] = useState<CharacterSheetInterface>(character.transform === null ? character : character.transform);
  const [owner, setOwner] = useState<User | null>(null);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculate = useCallback(() => {
    console.log("recalculate");
    setTimeout(() => {
      char_util.repopulateCharFeatureBases(char);
    }, 1000);
  }, [char]);

  const spellsChanged = useCallback( async () => {
    setTimeout( async () => {
      console.log("spellsChanged");
      await char_util.doRecalcs2(char, char);
      char_util.recalcSpells(char);
    }, 1000);
  }, [char]);

  const transformed = useCallback(() => {
    console.log(char.transform);
    
  }, [char]);
  
  const load = useCallback( async () => {
    // debugger;
    const new_obj = char;
    if (!new_obj.c_char) {
      new_obj.c_char = await api.getCampaignObject<CampaignChar>({ data_type: "campaign_char", filter: { char_id: new_obj._id }});
    }
    if (new_obj.c_char) {
      let c_char = new_obj.c_char;
      // It's part of a campaign, so treat it as such.
      if (!c_char.campaign) {
        const campaign = await api.getCampaign({ campaign_id: c_char.campaign_id, include: ["players","characters"] });
        if (campaign) {
          const c_char2 = campaign.c_chars.find(o => o._id === c_char._id);
          if (c_char2) {
            c_char = c_char2;
            new_obj.c_char = c_char;
          }
        }
      }
    }
    // if (new_obj.old_campaign_id === "" || !api.online) {
    //   // setCharInterface(new_obj.transform === null ? new_obj : new_obj.transform);
    //   if (api.user && new_obj.owner_id === api.user._id) {
    //     setOwner(api.user);
    //   } else {
    //     setLoading(true);
    //     const filter = {
    //       "_id*ObjectIDs": [new_obj.owner_id]
    //     };
        
    //     if (smart_api.apis.user) {
    //       smart_api.apis.user.getObjects({
    //         data_type: "user", 
    //         filter,
    //         ignore_templates: false
    //       }).then(res => {
    //         if (res.length === 1 && res[0] instanceof User) {
    //           setOwner(res[0]);
    //         }
    //         setLoading(false);
    //       });
    //     }
    //   }
    // } else {
    //   setLoading(true);
    //   setLoadingDetail("Campaign");
    //   // debugger;
    //   api.getObjects({ data_type: "campaign", filter: { "_id*ObjectIDs": [new_obj.old_campaign_id] } }).then(res2 => {
    //     if (res2.length === 1 && res2[0] instanceof Campaign) {
    //       const new_campaign = res2[0];
    //       api.getObjects({data_type: "character", filter: { campaign_id: new_campaign._id }}).then(res3 => {
    //         new_campaign.characters = res3 as Character[];
    //         new_obj.campaign = new_campaign;
    //         // setCharInterface(new_obj.transform === null ? new_obj : new_obj.transform);
    //         setCampaign(new_campaign);
    //         if (api.user && new_obj.owner_id === api.user._id) {
    //           setOwner(api.user);
    //           setLoading(false);
    //         } else {
    //           setLoading(false);
    //           const filter = {
    //             "_id*ObjectIDs": [new_obj.owner_id]
    //           };
        
    //           if (smart_api.apis.user) {
    //             smart_api.apis.user.getObjects({
    //               data_type: "user", 
    //               filter,
    //               ignore_templates: false
    //             }).then(res => {
    //               if (res.length === 1 && res[0] instanceof User) {
    //                 setOwner(res[0]);
    //               }
    //               setLoading(false);
    //             });
    //           }
    //         }
    //       });
    //     }
    //   });
    // }
    setFetched(true);
  }, [char]);

  // const subscribed = useRef(false);

  useEffect(() => {
    // if (subscribed.current) return;
    // subscribed.current = true;
  
    char.subscription_holder.subscribe("Recalculate", mounted, recalculate);
    char.subscription_holder.subscribe("Transform", mounted, transformed);
    char.subscription_holder.subscribe("Spells", mounted, spellsChanged);
    setTimeout(() => {
      load();
    }, 100);
  }, [char, load, recalculate, spellsChanged, transformed]);

  const renderBar1 = () => {
    // console.log("renderBar1");
    const recalc_time = char.recalc_time;
    return (
      <Grid size={12} className="bg_black_transp padded">
        <Grid container spacing={0} direction="row">
          <Grid size={4}>
            <div style={{ float: "left" }}>
              <CharacterImageButton 
                character={char}
                disabled={shared}
              />
            </div>
            <div style={{ float: "left" }}>
              <Grid container spacing={0} direction="row">
                <Grid
                  style={{ marginLeft: "4px" }}
                  size={12}>
                  <EditableLabel 
                    name="Name"
                    value={char.name}
                    fontSize={24}
                    disabled={shared}
                    flash_on_empty
                    onChange={(changed: string) => {
                      const new_obj = char;
                      new_obj.name = changed;
                      new_obj.changed();
                    }}
                  />
                </Grid>
                <Grid
                  style={{ marginLeft: "4px" }}
                  size={12}>
                  <CharacterLevelDisplay character={char} />
                </Grid>
                { owner && 
                  <Grid
                    style={{ 
                        fontSize: "8px", 
                        color: "gray", 
                        marginLeft: "4px"
                      }}
                    size={12}>
                    { owner.profile_name }
                  </Grid>
                }
                <Grid
                  style={{ marginLeft: "4px" }}
                  size={12}>
                  <CharacterTransformButton
                    character={char}
                    show_name
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid size={5}
            container spacing={0} direction="row">
            <Grid size={12}>
              <CharacterClassButton 
                character={char}
                disabled={shared}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <CharacterRaceButton
                character={char}
                disabled={shared}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              { !char.sidekick &&
                <CharacterBackgroundButton
                  character={char}
                  disabled={shared}
                />
              }
            </Grid>
          </Grid>
          <Grid size={3}
            container spacing={0} direction="row">
            <Grid size={12}>
              <div style={{ float: "right", marginRight: "4px", maxWidth: "245px" }}>
                <Grid container spacing={0} direction="row">
                  <Grid size={12}>
                    <HPInput 
                      char={char.char_interface}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterInspirationButton 
                      char={char}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterAdvantageButton 
                      char={char}
                    />
                  </Grid>
                </Grid>
              </div>
              <div style={{ float: "right", marginRight: "4px", maxWidth: "125px" }}>
                <Grid container spacing={0} direction="row">
                  <Grid size={4}>
                    <CharacterRestButton 
                      char={char}
                    />
                  </Grid>
                  <Grid size={4}>
                    <CharacterKnowledgeButton 
                      char={char}
                    />
                  </Grid>
                  <Grid size={4}>
                    <CharacterGiftButton 
                      character={char}
                      disabled={shared}
                      recalc_time={recalc_time}
                    />
                  </Grid>
                  { char.character_options.use_bastions && 
                    <Grid size={4}>
                      <CharacterBastionButton 
                        character={char}
                        disabled={shared}
                        recalc_time={recalc_time}
                      />
                    </Grid>
                  }
                  <Grid size={4}>
                    <CharacterTransformButton
                      character={char}
                    />
                  </Grid>
                  { char.campaign &&
                    <Grid size={4}>
                      <CharacterMailButton 
                        char={char}
                        disabled={shared}
                        recalc_time={recalc_time}
                      />
                    </Grid>
                  }
                  <Grid size={4}>
                    <CharacterNotesButton 
                      char={char}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  const renderBar2 = () => {
    // console.log("renderBar2");
    return (
      <>
        <Grid
          style={{ borderTop: "1px solid" }}
          className="bg_black_transp"
          size={{
            xs: 3
          }}>
          <CharacterSizeButton
            character={char}
          />
        </Grid>
        <Grid size={9} style={{ borderTop: "1px solid" }} className="bg_black_transp">
          <Grid container spacing={0} direction="row">
            <Grid size={3}>
              <CharacterProficiencyBonus
                character={char}
              />
            </Grid>
            <Grid size={3}>
              <CharacterSpeedButton
                character={char}
              />
            </Grid>
            <Grid size={3}>
              <CharacterInitiative
                character={char}
              />
            </Grid>
            <Grid size={3}>
              <CharacterACButton
                char={char}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  if (!fetched || loading) {
    return (<LoadingBox message={loading_detail} size={window.innerHeight * 0.5} height={window.innerHeight - 81} />);
  } else if (api.user === null && !shared) {
    return <Navigate to="/" />;
  } else { 
    // console.log("Char Sheet");
    return (
      <Grid container spacing={0} direction="row" className="dracoLich" style={{ 
        lineHeight: "1.5", 
        backgroundSize: "cover", // `${window.innerWidth}px`, 
        backgroundAttachment: "fixed", 
        backgroundImage: (char.bg_image_url === "" ? undefined : `url(${char.bg_image_url})`),
      }}>
        <Grid size={12}>
          <Grid container spacing={0} direction="row">
            { renderBar1() }
            { renderBar2() }
          </Grid>
        </Grid>
        <Grid size={12}>
          <CharacterMainDetails 
            character={char}
            // campaign={campaign}
            shared={shared}
          />
        </Grid>
        <CustomRolls
          char_interface={char.char_interface}
        />
      </Grid>
    ); 
  }
}
